const organisation = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '0203 318 9792',
    contactType: 'customer service'
  },
  logo: 'https://static.justpark.com/logo/justpark.png',
  name: 'JustPark',
  owns: {
    '@type': 'SoftwareApplication',
    name: 'JustPark',
    operatingSystem: ['ANDROID', 'iOS'],
    applicationCategory: 'Travel',
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: 4.8,
      ratingCount: 22148
    },
    offers: {
      '@type': 'Offer',
      price: '0',
      priceCurrency: 'GBP'
    }
  },
  sameAs: [
    'https://www.facebook.com/JustParkHQ/',
    'https://www.instagram.com/justparkhq/',
    'https://twitter.com/JustPark'
  ],
  url: 'https://www.justpark.com/'
};

export default organisation;
